import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { SubComponentFunction } from 'react-table';

import type { Conversion } from '@feathr/blackbox';
import type { ITableObjectProps } from '@feathr/components';
import { Table } from '@feathr/components';

interface IConversionsTableProps extends ITableObjectProps<Conversion> {
  columnIds: string[];
  SubComponent?: SubComponentFunction;
}

function ConversionsTable({
  columns,
  columnIds,
  items,
  sort,
  SubComponent,
  ...rest
}: Readonly<IConversionsTableProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Table<Conversion>
      {...rest}
      columns={columns.filter((column) => columnIds.includes(column.id!))}
      initialSort={sort ?? [{ id: 'd_c' }]}
      isPaginated={true}
      items={items}
      manual={true}
      noDataText={t('No Conversions')}
      sort={sort}
      SubComponent={SubComponent}
    />
  );
}

export default observer(ConversionsTable);
